import { api, getBlob } from "../../services/NetworkBase";

export async function SaveEliIcImportData(importedData) {
  try {
    let response = await api.post("vlp/instrument-data/eli-ic", {
      json: importedData,
    });
    return response;
  } catch (error) {
    throw error;
  }
}


export async function SaveEliATIImportData(importedData) {
  try {
    let response = await api.post("vlp/instrument-data/eli-ati", {
      json: importedData,
    });
    return response;
  } catch (error) {
    throw error;
  }
}
